module.exports = __webpack_public_path__ + "img/inco6.e4a7cc1f.png";